import Container from "@components/Atomic/Container/Container";
import { StyledContainer } from "@components/Styled/Container";
import { styledWithInvalidProps } from "@components/Styled/StyledWithInvalidProps";
import React from "react";
import tw, { styled } from "twin.macro";
import { RichTextOutputProps, withRichtext } from "./withRichtext";
import { NestedWrapper } from "../NestedWrapper";

const Wrapper = styledWithInvalidProps(StyledContainer)(
  ({ padding }: { padding?: "yes" | "no" }) => [
    padding === "yes" ? tw`py-giga` : null,
  ],
);

const RichtextWrapper = styled.div`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    ${({ mobileAlignment }) =>
      mobileAlignment === "center" ? tw`text-center` : tw`text-left`}
    ${({ desktopAlignment }) =>
      desktopAlignment === "center" ? tw`md:text-center` : tw`md:text-left`}
  }
`;

const Parent = ({
  children,
  mobileAlignment,
  desktopAlignment,
  width,
  padding,
}: Partial<RichTextOutputProps>) => {
  return (
    <Wrapper width={width} padding={padding}>
      <RichtextWrapper
        mobileAlignment={mobileAlignment}
        desktopAlignment={desktopAlignment}
      >
        {children}
      </RichtextWrapper>
    </Wrapper>
  );
};

const Child = ({ content }: Partial<RichTextOutputProps>) => {
  return <div className="rte">{content}</div>;
};

const Richtext = withRichtext(({ background, styles, nested, ...rest }) => {
  return (
    <Container
      as={nested ? "section" : "div"}
      styles={styles}
      legacy={!styles?.length}
      background={background}
      data-component-type="section-rich-text"
    >
      <NestedWrapper
        {...rest}
        nested={nested}
        renderChild={Child}
        renderParent={Parent}
      />
    </Container>
  );
});

export default Richtext;
